module.exports = __webpack_public_path__ + "img/poster alyssa.079b0e83.jpg";